<script setup lang="ts">
/**
 * UiKitRadioGroup — контейнер радио-группы HeroUI UI-kit. Figma: 483-43628.
 * Управляет выбором, цветом и размером дочерних UiKitRadio через provide/inject.
 */
import type { HuiColor, HuiSize } from './palette'
import { UI_KIT_RADIO_GROUP, type RadioGroupContext } from './radioContext'

const props = withDefaults(
  defineProps<{
    color?: HuiColor
    size?: HuiSize
    orientation?: 'vertical' | 'horizontal'
    disabled?: boolean
    invalid?: boolean
    label?: string
  }>(),
  { color: 'primary', size: 'md', orientation: 'vertical', disabled: false, invalid: false, label: '' },
)

const model = defineModel<string | number>()

defineOptions({ name: 'UiKitRadioGroup' })

provide<RadioGroupContext>(UI_KIT_RADIO_GROUP, {
  name: `uikit-radio-${Math.random().toString(36).slice(2, 9)}`,
  color: computed(() => props.color),
  size: computed(() => props.size),
  disabled: computed(() => props.disabled),
  invalid: computed(() => props.invalid),
  selected: model,
  select: (v: string | number) => { if (!props.disabled) model.value = v },
})
</script>

<template>
  <div role="radiogroup" :aria-label="label || undefined">
    <span v-if="label" class="block mb-2 text-sm text-hui-foreground/70">{{ label }}</span>
    <div class="flex gap-3" :class="orientation === 'vertical' ? 'flex-col' : 'flex-row flex-wrap'">
      <slot />
    </div>
  </div>
</template>
